(ns ycweb.app.website.school.course.detail
  (:require
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.school.common :as school.common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]))

(rum/defc course-overview < rum/reactive [app-atom]
  (let [state-atom (cmn/action-cursor app-atom)
        user (cmn/curact state-atom [:user])
        course (cmn/curact state-atom [:course])

        {:course/keys [host host-name modules progress user-course-uuid]} course
        {:user/keys [firstname]} user

        progress (trf/tonumber progress 0)]

    (list
      [:main {:id "main-content"}
       [:div
        {:class (u/bem :header-banner [:has-avatar] :u-bg-oil)}
        [:div.header-banner__text-wrapper
         [:div.header-banner__text.u-text-white
          [:div.header-banner__avatar
           (web-common/lazy-image app-atom
             (:doc/public-id (:ent/image host))
             {:class ["avatar  yc-simple-image  yc-simple-image--full  yc-simple-image--border  yc-simple-image--shadow"]}
             {:w 140
              :h 140
              :q "auto"})]
          [:h1.header-banner__title
           (:ent/display-name course)
           [:span.header-banner__subtitle "Presented by " (:ent/display-name host)]]]]
        [:div.header-banner__image-wrapper
         (web-common/lazy-image app-atom
           (:doc/public-id (:ent/image course))
           {:class ["header-banner__image"]}
           {:w 1920
            :mw 490
            :dpr 2
            :q "auto"
            :alt host-name})]
        (toaster/loading-overlay app-atom :web.cooking-school/course-overview)]

       (when (> progress 0)
         [:div
          {:class (u/bem :yc-section [:standard])}
          [:div.u-block-center.u-max-width-720
           (headings/heading "Your course progress:"
             {:type :h2
              :size :tiny
              :class "u-margin-bottom-40"})

           [:div.course-progress-tracker.u-margin-top-30
            {:title (str progress "% complete")}
            [:div
             {:class (u/bem :course-progress-tracker__bar [(when (= progress 100) :complete)])
              :style {:width (str progress "%")}}
             [:small.hidden-from-view (str progress "% complete")]]]

           (cond
             (= progress 100)
             (list
               [:p.yc-paragraph.u-text-center
                "Congratulations! You've completed " (:ent/display-name course) " and have unlocked your course certificate!"]
               [:div.u-block-center.u-max-width-240
                (buttons/button-web "Download Certificate"
                  (merge
                    {:href (str "/api/school/certificate/" (str user-course-uuid) ".pdf")
                     :style :primary
                     :size :default
                     :full true
                     :target "_blank"}))])

             :else
             [:p
              {:class (u/bem :yc-paragraph [:flush] :u-text-center)}
              (str "Nicely done" (when (u/presence firstname) (str ", " firstname))
                ". You're " progress "% of the way to unlocking your course certificate.")])]
          (toaster/loading-overlay app-atom :web.cooking-school/course-overview)])

       [:div
        {:class (u/bem :yc-section [:large])}
        (map-indexed
          (fn [idx module]
            [:div
             {:class (u/bem :yc-section [:standard])
              :key idx}
             (school.common/lesson-card app-atom idx module)])
          modules)
        (toaster/loading-overlay app-atom :web.cooking-school/course-overview)]])))

(defmethod flow/render-screen :web.cooking-school/mycourseview [app-atom _]
  (website/screen-wrapper app-atom
    (course-overview app-atom)
    {:pagetype :school}))

(defmethod t/transition-open :web.cooking-school/mycourseview [app-atom _ params]
  (toaster/open-overlay app-atom :web.cooking-school/course-overview)

  (swap! (cmn/action-cursor app-atom) assoc :course nil :user nil)
  (comms/ajax-get :web.cooking-school/mycourseview {:ent/uuid (:uuid params)}))

(defmethod comms/receive :web.cooking-school/mycourseview [app-atom e]
  (toaster/close-overlay app-atom :web.cooking-school/course-overview)

  (swap!
    (cmn/action-cursor app-atom) assoc
    :course (:course e)
    :user (:user e)))
